import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_209hchofxn: FaireBrandEntity = {
  token: "b_209hchofxn",
  type: "brand",
  name: "Kyn You Believe It",
  avatarUrl:
    "https://cdn.faire.com/fastly/3b953c53f2484b257211a8592128e7ba5e340aee32906917c69f2ace3b9bdc62.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e2f3b9ce26a9369ad21b58f337cb275640a27229c219db5b0230d70013c64c56.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/3b953c53f2484b257211a8592128e7ba5e340aee32906917c69f2ace3b9bdc62.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e2f3b9ce26a9369ad21b58f337cb275640a27229c219db5b0230d70013c64c56.jpeg",
  location: "Lockhart, TX, USA",
  minimumOrderDollars: 208,
  rating: 5,
  reviewCount: 41,
  isTopShop: true,
  isInsider: true,
  description:
    "New to KYBI?\n- view the catalog at kynyoubelieveit.com/catalog\n- request samples at kynyoubelieveit.com/sample\n- view terms and conditions at kynyoubelieveit.com/wholesale-terms\n\n**BARCODES** – we are currently in the process of adding GTIN / UPC barcodes to all wholesale products! During this transition, please message us after placing your order if you'd like to ensure your items receive barcodes and we'll make a note. :-)\n\n-----------\n\nWelcome! We're so happy you're here. Kyn You Believe It (aka: KYBI) is a colorful stationery and gift brand centered around mental health and self-care. KYBI was started by Kyndra in 2019, and our growth has been a \"slow but steady\" story. Overtime, we've found a place in this world as a brand that advocates for mental health, encourages being your truest self, and overall, just reminds you to not take life too seriously. With over 40,000 orders shipped, it's a true joy to know we're adding extra sunshine into the world.\n\nWhen you order wholesale from Kyn You Believe It, you'll be supporting art that was hand-drawn – and sometimes even hand-printed – by Kyndra! Additionally, our most popular paper products are made in-house by our small team of 3 to to ensure highest quality and price accessibility.\n\nTake a look around; it's sure to be love at first sight for you AND your customers. If you have any questions, please message us or reach out at [redacted-email]. We look forward to working with you!",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:34.968Z",
    importedBy: "entity-db-cli",
  },
};
